import reduceReducers from 'reduce-reducers'
import createFetchModule from '@utils/store/createFetchModule'
import { FetchActionsWith } from '@typings/generic'
import createFetchSubmodule from '@utils/store/createFetchSubmodule'

export const moduleName = 'reservationTransfersGrid'

const fetchModule = createFetchModule('@store/ReservationTransfersGrid', 'LOAD', moduleName)
const exportReservationsOnTransfersSubmodule = createFetchSubmodule('@store/ReservationTransfersGrid', 'EXPORT', moduleName)

export const actionTypes = {
  ...fetchModule.actionTypes,
  exportReservations: exportReservationsOnTransfersSubmodule.actionTypes,
}

export default reduceReducers(fetchModule.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
  exportReservations: exportReservationsOnTransfersSubmodule.actions.run,
}

export const selectors: Selectors = {
  ...fetchModule.selectors,
}
